package com.eladfinish.bible.contest.screens.browse.usecases.chumash

import com.eladfinish.bible.contest.constants.StringConstants.MAKAF
import com.eladfinish.bible.contest.constants.StringConstants.Regex.WHITESPACE
import com.eladfinish.bible.contest.constants.StringConstants.Regex.WORD_CHAR_BOUNDARY
import com.eladfinish.bible.contest.extensions.end
import com.eladfinish.bible.contest.extensions.replaceRegex
import com.eladfinish.bible.contest.extensions.start
import com.eladfinish.bible.contest.utils.MyStringUtils
import com.eladfinish.bible.contest.utils.makeVavAndYudOptional

class GetParashaNameSpannedUseCase {

    fun getParashaNameSpanned(content: String, parashaName: String): Pair<Int, Int> {
        // WHITESPACE rather than \s: iOS's \s doesn't match NBSP (see WHITESPACE)
        val regex = "[^$WHITESPACE$MAKAF]{0,2}${parashaName.makeVavAndYudOptional()}"
            .replaceRegex(
                regex = "(${"[." + "א-ת" + "]"}(?:${MyStringUtils.getSiman()}\\??)*)",
                replacement = "(?:$1@)"
            )
            .replace(
                oldValue = "@",
                newValue = "[^א-ת־׃$WHITESPACE]" + "*"
            )
            .trim()
            .replaceRegex(
                regex = "\\s",
                replacement = "[ ־]"
            )
            // WORD_CHAR_BOUNDARY rather than \b: JS RegExp's \b is ASCII-only (see WORD_CHAR).
            // Prepended last, so the letter rewriting above doesn't touch its א-ת range.
            .let { "$WORD_CHAR_BOUNDARY$it" }

        return regex.toRegex().find(content)?.let {
            it.start to it.end
        } ?: (0 to 0)
    }

}
